export default "__VITE_ASSET__EV1Cnoie__"